export default __webpack_public_path__ + "svg/calendar/2025/5/junio.svg?cb81de2f";